// Standalone consent controller: deliberately independent of generated theme.js.
(() => {
  if (customElements.get('cg-cookie-consent')) return;
  class CookieConsent extends HTMLElement {
    constructor() {
      super();
      this.refresh = () => {
        const api = window.Shopify?.customerPrivacy;
        if (!api || this.saving || window.Shopify.designMode) return;
        const choice = api.currentVisitorConsent();
        const saved = ['analytics', 'marketing'].every(key => ['yes', 'no'].includes(choice?.[key]));
        this.hidden = saved || !api.shouldShowBanner();
      };
      this.clickHandler = event => {
        const button = event.target.closest('[data-action]');
        if (!button || !this.contains(button)) return;
        if (button.dataset.action === 'close') this.hidden = true;
        if (button.dataset.action === 'accept') this.save(true);
        if (button.dataset.action === 'decline') this.save(false);
      };
    }
    connectedCallback() {
      this.addEventListener('click', this.clickHandler);
      window.addEventListener('pageshow', this.refresh);
      document.addEventListener('visitorConsentCollected', this.refresh);
      if (window.Shopify?.customerPrivacy) this.refresh();
      else if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
          if (!error) this.refresh();
        });
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.clickHandler);
      window.removeEventListener('pageshow', this.refresh);
      document.removeEventListener('visitorConsentCollected', this.refresh);
    }
    error() {
      this.hidden = false;
      if (this.querySelector('[data-consent-error]')) return;
      const message = document.createElement('p');
      message.setAttribute('data-consent-error', '');
      message.setAttribute('role', 'alert');
      message.className = 'text-xs';
      message.textContent = 'Your cookie choice could not be saved. Please try again.';
      this.querySelector('.privacy-bar__inner').append(message);
    }
    save(accepted) {
      if (this.saving) return;
      const api = window.Shopify?.customerPrivacy;
      if (!api) { this.error(); return; }
      this.saving = true;
      this.querySelector('[data-consent-error]')?.remove();
      const buttons = this.querySelectorAll('button');
      buttons.forEach(button => { button.disabled = true; });
      let done = false;
      const finish = result => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        this.saving = false;
        buttons.forEach(button => { button.disabled = false; });
        const choice = api.currentVisitorConsent();
        const expected = accepted ? 'yes' : 'no';
        if (result?.error || !['analytics', 'marketing'].every(key => choice?.[key] === expected)) {
          this.error();
        } else this.hidden = true;
      };
      const timer = setTimeout(() => finish({error: 'timeout'}), 10000);
      try {
        api.setTrackingConsent({analytics: accepted, marketing: accepted}, finish);
      } catch (error) { finish({error}); }
    }
  }
  customElements.define('cg-cookie-consent', CookieConsent);
})();
